import LineItemColumnKind from './lineItemColumnKind';

export default [] as LineItemColumnKind[];
